import React, { useContext, useEffect, useState } from 'react'
import { ProjectContext } from '../../../context/ProjectContext'
import { MeetingsFilters } from '../../dashboard/meetings/filters'
import { Meeting } from '../../dashboard/meetings/meeting'
import FiltersIcon from '../../icons/Filters'
import { getMeetingProvider } from '@/utils'
import { EmptyState } from './EmptyState'
import { useCustomFetch } from '@/hooks/useCustomFetch'

export function Meetings() {
  const { sessions, isLoading, indexedValidations, project, setMeetings } = useContext(ProjectContext)
  const customFetch = useCustomFetch()

  const [validationFilter, setValidationFilter] = useState('')
  const [sourceFilter, setSourceFilter] = useState('')
  const [filteredSessions, setFilteredSessions] = useState([])

  useEffect(() => {
    applyFilters()
  }, [sessions])

  function handleValidationFilter(isProspectToUseIt = '') {
    setValidationFilter(isProspectToUseIt)
    applyFilters(isProspectToUseIt, sourceFilter)
  }

  function handleSourceFilter(source = '') {
    setSourceFilter(source)
    applyFilters(validationFilter, source)
  }

  function applyFilters(validation = validationFilter, source = sourceFilter) {
    let filtered = [...sessions]

    if (validation) {
      filtered = filtered.filter((meet) => indexedValidations[meet.id]?.is_prospect_to_use_it === validation)
    }

    if (source) {
      filtered = filtered.filter((meet) => getMeetingProvider(meet.meeting_url) === source)
    }

    setFilteredSessions(filtered)
  }

  async function handleCreateEmptyMeet() {
    const response = await customFetch('/createEmptyMeeting', 'POST', { projectId: project.id })
    setMeetings((prevMeetings) =>
      [response.meeting, ...prevMeetings].sort((a, b) => {
        let timeA = a.created_at
        let timeB = b.created_at
        if (a.start) {
          timeA = new Date(a.start).getTime()
        }
        if (b.start) {
          timeB = new Date(b.start).getTime()
        }
        return timeA < timeB ? 1 : -1
      })
    )
  }

  return (
    <div className="px-[50px] py-[30px] w-full overflow-y-auto">
      <div className="w-full mb-[15px] flex justify-between items-center">
        <p className="text-[#3f424a] text-[26px] font-semibold font-['Manrope'] leading-[29.90px]">Meetings</p>

        <div className="w-auto h-12 bg-white rounded-[10px] flex item-center">
          <div className="relative border-r border-[#e4e4e4] flex justify-center items-center">
            <div className="py-3.5 px-5 flex justify-center items-center gap-1">
              <FiltersIcon />
              <p className="text-black text-base font-bold font-['Manrope'] leading-tight ms-1">FILTERS</p>
            </div>
          </div>

          <div className="relative flex justify-center items-center">
            <button className="py-3.5 flex justify-center items-center gap-1">
              <MeetingsFilters
                projectFilterEnabled={false}
                validation={validationFilter}
                setValidation={handleValidationFilter}
                source={sourceFilter}
                setSource={handleSourceFilter}
              />
            </button>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-[calc(100vh-200px)]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF4A8E]" />
        </div>
      ) : filteredSessions.length === 0 ? (
        <EmptyState
          onCreateEmptyMeet={handleCreateEmptyMeet}
          projectId={project.id}
          projectName={project.name}
          setMeetings={setMeetings}
        />
      ) : (
        <div className="flex flex-wrap gap-9">
          {filteredSessions.map((meeting) => (
            <Meeting
              key={meeting.id}
              meeting={meeting}
              validation={indexedValidations[meeting.id]?.is_prospect_to_use_it}
              fromProject={true}
            />
          ))}
        </div>
      )}
    </div>
  )
}
